import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IUniform, IUniformInitialState } from "./uniformModel";
import {
  ActiveInactiveUniform,
  createUniform,
  deleteUniform,
  getAllActiveUniform,
  getAllUniform,
  getUniformByID,
  UniformImageUpload,
  updateUniform,
} from "./services/uniform.services";

const initialState: IUniformInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  UniformID: null,
  UniformList: [],
  UniformDetail: {
    IndustriesID: null,
    Title: "",
    Description: "",
    SequenceNo: null,
    IsActive: 1,
  },
};

const uniformSlice = createSlice({
  name: "uniform",
  initialState,
  reducers: {
    clearUniformDetails: (state) => {
      state.UniformDetail = initialState.UniformDetail;
    },
    setUniformID: (state, action) => {
      state.UniformID = action.payload;
    },
    clearUniformID: (state) => {
      state.UniformID = initialState.UniformID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllUniform.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllUniform.fulfilled,
      (state, action: PayloadAction<IUniform[]>) => {
        state.loading = false;
        state.UniformList = action.payload || [];
      }
    );
    builder.addCase(getAllUniform.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.UniformList = [];
    });
    builder.addCase(createUniform.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createUniform.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createUniform.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateUniform.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(updateUniform.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateUniform.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteUniform.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteUniform.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteUniform.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getUniformByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getUniformByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.UniformDetail = action.payload;
    });
    builder.addCase(getUniformByID.rejected, (state, action) => {
      state.formLoading = false;
      state.UniformDetail = initialState.UniformDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveUniform.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveUniform.fulfilled,
      (state, action: PayloadAction<IUniform[]>) => {
        state.loading = false;
        state.UniformList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveUniform.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.UniformList = [];
    });
    builder.addCase(ActiveInactiveUniform.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveUniform.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveUniform.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(UniformImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(UniformImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(UniformImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearUniformDetails, clearUniformID, setUniformID } =
  uniformSlice.actions;
export default uniformSlice.reducer;
